<div class="service-card bg-white text-center p-5 w-100 max-500 height-440 border-radius-10 m-auto mrb-10 mrb-lg-0 box-shadow">
    <div class="service-card-img"><img class="w-100 max-300 height-350 border-radius-10"
            [src]="image" alt="card img" defaultImage></div>
    <div class="service-card-body pse-10">
        <div class="service-card-title text-center size-9 weight-700 ptb-10 pse-5">{{ name }}</div>
    </div>
  </div>
